import { ShareBaseDocument } from 'phoenix/domain';
import { OfficeOnlineService } from 'sharebase/services';
import { IStorageAccessor } from 'util/domain/storage-types';
import { ErrorDialog } from '../errorDialog/errorDialog';
import { LaunchDialog } from '../launchDialog/launchDialog';

const template = require('./officeOnlineViewer.template');
const THREE_WEEKS_IN_MS = 1000 * 3600 * 24 * 7 * 3;
require('./officeOnlineViewer.styles');

export class OfficeOnlineViewer implements ng.IComponentController { 
	public static $inject = [
		'$q',
		'$sce',
		'$timeout',
		'sbOfficeOnlineService',
		'wopiLaunchDialog',
		'wopiErrorDialog',
		'localStorageService',
	];

 	// URL may have to be appended with extra params for i18n, etc.
	public actionUrl:string;
	public accessToken:string;
	public accessTokenTtl:number;

	public document:ShareBaseDocument

	constructor (
		private $q:ng.IQService,
		private $sce:ng.ISCEService,
		private $timeout:ng.ITimeoutService,
		private sbOfficeOnlineService:OfficeOnlineService,
		private wopiLaunchDialog:LaunchDialog,
		private wopiErrorDialog:ErrorDialog,
		private localStorageService:IStorageAccessor,
	) {
		let lastLaunch = +this.localStorageService.getStoredValue('office-online-last-launch') || 0;
		let dialogPromise = Date.now() - lastLaunch > THREE_WEEKS_IN_MS 
			? this.wopiLaunchDialog.show(this.document)
			: this.$q.resolve();

		let discoveryPromise = this.sbOfficeOnlineService
			.discover(this.document)
			.then(res => {
				this.actionUrl = this.$sce.trustAsResourceUrl(res.ActionUrl);
				this.accessToken = res.TokenStr;
				this.accessTokenTtl = res.AccessTokenTtl;
				this.setFavicon(res.FaviconUrl);
			});

		this.$q.all([dialogPromise, discoveryPromise])
			.then(() => this.loadFrame())
			.catch(e => this.wopiErrorDialog.show(this.document.DocumentName))
			.finally(() => this.localStorageService.setStoredValue('office-online-last-launch', Date.now().toString()));
	}

	public $onDestroy() {
		this.setFavicon();
	}

	// to avoid browser issues with iframes, the viewer frame must be dynamically crafted 
	// https://wopi.readthedocs.io/en/latest/hostpage.html#working-around-browser-iframe-behavior
	private loadFrame() {
		let frameholder = document.getElementById('frameholder');
		let officeFrame = document.createElement('iframe');

		officeFrame.name = 'office_frame';
		officeFrame.id = 'office_frame';
		officeFrame.title = 'Office Online Frame';
		officeFrame.setAttribute('allowfullscreen', 'true');
		officeFrame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox');

		frameholder.appendChild(officeFrame);

		// trigger next digest cycle to update interpolated form values.
		this.$timeout(() => (document.getElementById('office_form') as HTMLFormElement).submit(), 0);
	}

	private setFavicon(href = 'icons/favicon.ico') {
		let link = document.querySelector(`link[rel*='icon']`) as HTMLLinkElement;
		link.href = href;
	}
}

export const OfficeOnlineViewerComponent:ng.IComponentOptions = {
	template,
	controller: OfficeOnlineViewer,
	controllerAs: 'vm',
	bindings: {
		document: '<'
	}
}



// WEBPACK FOOTER //
// ./src/office-online/components/officeOnlineViewer/officeOnlineViewer.ts